export const GET_SETTINGS = "GET_SETTINGS";
export const SET_APP_MODE = "SET_APP_MODE";
